import * as React from "react";

interface Props {
    values: any[],
    icon?: string,
    name?: string,
    placeholder?: string,
    label?: string,
    required?: boolean,
    value?: any,
    onChange?: any
}

interface State {
    value?: any
}

export default class FormSelect extends React.Component<Props, State> {
    name: string;

    constructor(props) {
        super(props);
        this.name = this.getName();

        this.state = {
            value: this.props.value
        }
    }

    getName() {
        if(this.props.name)
            return this.props.name;

        if(this.props.label)
            return this.props.label.toLowerCase();

        let rnd = Math.floor(Math.random() * 999999) + 1;

        return "form-select-" + rnd;
    }

    getLabel() {
        return this.props.label ?
            <label className={"label_select"} htmlFor={this.name}>{this.props.label}
                { this.props.required && <span className="required">*</span> }
            </label> : "";
    }

    writeOption(item, i) {
        if(item.key == this.state.value)
            return (<option value={item.key} key={i} selected>{item.value}</option>);
        return (<option value={item.key} key={i}>{item.value}</option>);
    }

    onChange(e) {
        if(this.props.onChange) 
            this.props.onChange(this.name, e.target.value);

        this.setState({
            value: e.target.value
        });
    }

    getSelect() {
        return (
            <select className="form-control" name={this.name} onChange={(event) => this.onChange(event)} style={ { width: '130%', backgroundColor: 'transparent' } }>
                { this.props.placeholder &&
                    (<option value={"null"}>{this.props.placeholder}</option>)
                }
                {
                    this.props.values.map((item, i) => this.writeOption(item, i))
                }
            </select>
        );
    }

    render() {
        let icon = "glyphicon glyphicon-chevron-down";
        if(this.props.icon)
            icon = this.props.icon;

        return (
            <div className="form-group">
                { this.getLabel() }
                <div className={"custom-select"}>
                    {
                        <div className="input-group">
                            { this.getSelect() }
                            <span className="input-group-addon">
                                <i className={icon}></i>
                            </span>
                        </div>
                    }
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/FormSelect.tsx